import { useEffect, useRef } from 'react'
import { Flex, Text, Link, InjectedModalProps, useModal } from 'vvs-uikit'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useAcceptance } from 'state/vvsgotchi/hooks/useSignAuthAndAcceptance'
import { useTranslation } from 'contexts/Localization'
import useGotchiOwner from 'state/vvsgotchi/hooks/useGotchiOwner'
import { GotchiModal } from 'views/VvsGotchi/components/Modal'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { getVVSMinerMoleMintedUrl } from 'utils/mintedNftCollectionUrls'

const NoMoleModalListener = () => {
  const { account } = useActiveWeb3React()
  const { owner, moles, loading } = useGotchiOwner()
  const [requireAcceptance] = useAcceptance()
  const modalSwitches = useModal(<NoMoleModal />, true, false, 'vvsgotchiAcceptance')
  const modalSwitchesRef = useRef(modalSwitches)
  modalSwitchesRef.current = modalSwitches

  useEffect(() => {
    const [openModal, , , isOpen] = modalSwitchesRef.current
    if (
      account &&
      !requireAcceptance &&
      !loading &&
      owner &&
      moles.length <= 0 &&
      !isOpen // prevent replace other modal if already opened
    ) {
      openModal()
    }
  }, [loading, requireAcceptance, account, owner, moles])

  return null
}

export default NoMoleModalListener

const NoMoleModal: React.FC<InjectedModalProps> = ({ onDismiss }) => {
  const { t } = useTranslation()

  return (
    <GotchiModal onDismiss={onDismiss}>
      <Flex justifyContent="center" mb={3}>
        <PixelatedImage src="/images/vvsGotchi/vvs_gotchi_mole_row.png" alt="VVS Miner Moles" width="224px" />
      </Flex>
      <Text fontSize="20px" textAlign="center" fontWeight="600" mb="8px" color="black">
        {t('No Moles Found')}
      </Text>
      <Text mb={4} textAlign="center" color="black">
        {t("It looks like you don't own a Miner Mole yet! Adopt one now on ")}
        <Text as="span" color="primary">
          <Link inline fontWeight="400" href={getVVSMinerMoleMintedUrl()} target="_self">
            {t('Minted Marketplace')}
          </Link>
        </Text>
        .
      </Text>
    </GotchiModal>
  )
}
